import { parseToDate } from "../../../../utils/dateUtils";

export const formatChildDate = (value, locale = "nl-NL") => {
  const date = parseToDate(value);
  return date ? date.toLocaleDateString(locale) : "-";
};

export const getWithdrawnDate = (child) =>
  child?.withdrawnAt || child?.withdrawnOn || child?.dateWithdrawn || child?.withdrawnDate || null;

export const formatWithdrawnDate = (child, locale = "nl-NL") => {
  const withdrawnDate = getWithdrawnDate(child);
  return withdrawnDate ? formatChildDate(withdrawnDate, locale) : null;
};

export const isChildWithdrawn = (child) =>
  Boolean(child?.withdrawn) ||
  String(child?.status || "").toLowerCase() === "withdrawn" ||
  Boolean(getWithdrawnDate(child));

export const maskBsn = (value, visibleDigits = 0) => {
  if (!value) return "";
  const str = String(value);
  const trimmed = str.trim();
  if (trimmed === "**") {
    return "•".repeat(8);
  }
  if (/^\*+$/.test(trimmed)) {
    return "•".repeat(trimmed.length);
  }
  const digitsOnly = str.replace(/\D/g, "");
  if (!digitsOnly.length) {
    return str.includes("*") ? str.replace(/\*/g, "•") : str;
  }
  const digitsToMask = Math.max(0, digitsOnly.length - visibleDigits);
  let maskedCount = 0;
  let result = "";
  for (const char of str) {
    if (/\d/.test(char)) {
      if (maskedCount < digitsToMask) {
        result += "•";
        maskedCount += 1;
      } else {
        result += char;
      }
    } else {
      result += char;
    }
  }
  return result;
};
